import React, { 
    useState, 
    useEffect, 
    useRef,
    memo
} from 'react';
import { 
    Card, 
    Form, 
    Col, 
    Button,
    Row,
    OverlayTrigger,
    Tooltip
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import uniqid from 'uniqid';
import moment from 'moment';
import axios from 'axios';

// componentes
import ComboCliente from '../../../Componentes/ComboCliente';
import InputData from '../../../Componentes/InputData';
import ComboModeloEmail from './../../../Componentes/ComboModeloEmail';
import BotaoTabela from '../../../Componentes/BotaoTabela';
import InputValor from './../../../Componentes/InputValor';
import ComboPlanos from '../../../Componentes/ComboPlanos';
import styles from '../index.module.scss';
import stylesCampos from './index.module.scss';
import Carregador from '../../../Componentes/Carregador';
import ComboGrupos from '../ComboGrupos';

function CamposSeguroAventura({
    dados,
    grupos,
    indice,
    idCliente,
    modoUsuario,
    dadosUsuario,
    gerandoApolice,
    emissaoContrato,
    gerandoContrato,
    downloadApolice,
    toastCopiarTexto,
    carregamentoToken,
    gerarTokenDiarias,
    alterarIdsCliente,
    realizarUploadTermo,
    realizarDownloadTermo,
    subindoTermoResponsabilidade,
    baixandoTermoResponsabilidade,
    dadosContratoAutentiqueCliente
}) {
    
    // verifica se é o cliente original e atribui
    const clienteOriginal = dados.id === idCliente;
    
    // estado global
    const configuracoes = useSelector(state => state.painel.configuracoesSistema);

    // referencias
    const arquivoRef = useRef(null);
    const refLinkPropriedade = useRef(null);
    
    // estados auxiliares
    const [carregando, alterarCarregando] = useState(false);
    const [escondido, alterarEscondido] = useState(true);
    const [habilitar, alterarHabilitar] = useState(false);
    const [mostrarLinkCliente, alterarMostrarLinkCliente] = useState(false);
    const [numeroDiariasInput, alterarNumeroDiariasInput] = useState(null);
    const [possuiGrupoSeguroAventuraAtivo, alterarPossuiGrupoSeguroAventuraAtivo] = useState(false);    
    const [dadosContratoAutentique, alterarDadosContratoAutentique] = useState(clienteOriginal ? dadosContratoAutentiqueCliente : null);
    const [camposJson, alterarCamposJson] = useState({
        linha: null,
        nome: "",
        cpf: "",
        email: "",
        dataNascimento: "",
        dataInicio: "",
        dataFinal: "",
        genero: "",
        telefone: ""
    });
    const [dadosPlano, alterarDadosPlano] = useState(null);
    
    // estados do formulário evento
    const [diariasCheckin, alterarDiariasCheckin] = useState(clienteOriginal ? (dados.diarias_evento_checkin ? JSON.parse(dados.diarias_evento_checkin) : []) : []);
    const [gruposCliente, alterarGruposCliente] = useState(clienteOriginal ? grupos : []);
    const [idClienteSeguradora, alterarIdClienteSeguradora] = useState(clienteOriginal ? dados.id_cliente_seguradora : '216');
    const [cartaOferta, alterarCartaOferta] = useState(clienteOriginal ? dados.carta_oferta : null);
    const [numeroApolice, alterarNumeroApolice] = useState(clienteOriginal ? dados.numero_apolice : null);
    const [vigenciaApolice, alterarVigenciaApolice] = useState(clienteOriginal ? dados.data_vigencia_apolice : moment(new Date()).subtract(1, 'month').endOf('month').format('YYYY-MM-DD'));
    const [numeroContrato, alterarNumeroContrato] = useState(clienteOriginal ? dados.numero_contrato : null);
    const [nomeEvento, alterarNomeEvento] = useState(clienteOriginal ? dados.seguro_evento_nome : null);
    const [descricaoEvento, alterarDescricaoEvento] = useState(clienteOriginal ? dados.seguro_evento_descricao : null);
    const [localEvento, alterarLocalEvento] = useState(clienteOriginal ? dados.seguro_evento_local : null);
    const [planoAdicionalDeslocamento, alterarPlanoAdicionalDeslocamento] = useState(clienteOriginal ? dados.plano_adicional_deslocamento : 'N');
    const [idPlano, alterarIdPlano] = useState(clienteOriginal ? dados.id_plano : null);
    const [idModeloEmailParticipante, alterarIdModeloEmailParticipante] = useState(clienteOriginal ? dados.seguro_id_modelo_email_participante : null);
    const [seguroValorDiaria, alterarSeguroValorDiaria] = useState(clienteOriginal ? dados.seguro_valor_diaria : null);
    const [seguroValorMorteAcidental, alterarSeguroValorMorteAcidental] = useState(clienteOriginal ? dados.seguro_valor_morte_acidental : null);
    const [seguroValorInvalidez, alterarSeguroValorInvalidez] = useState(clienteOriginal ? dados.seguro_valor_invalidez : null);
    const [seguroValorDmho, alterarSeguroValorDmho] = useState(clienteOriginal ? dados.seguro_valor_dmho : null);
    const [seguroHabilitarComprovanteParticipante, alterarSeguroHabilitarComprovanteParticipante] = useState(clienteOriginal ? dados.seguro_habilitar_comprovante_participante : "N");
    const [seguroHabilitarComprovanteParticipanteIndividual, alterarSeguroHabilitarComprovanteParticipanteIndividual] = useState(clienteOriginal ? dados.seguro_habilitar_comprovante_participante_individual : "N");
    const [seguroEventoFinalizadoPermiteClienteNovo, alterarSeguroEventoFinalizadoPermiteClienteNovo] = useState(clienteOriginal ? dados.seguro_evento_finalizado_permite_cliente_novo : "N");
    const [bloquearEnvioEmailsSeguroAventura, alterarBloquearEnvioEmailsSeguroAventura] = useState(clienteOriginal ? dados.bloquear_envio_emails_seguro_aventura : "N");
    const [exibirTermos, alterarExibirTermos] = useState(clienteOriginal ? dados.exibir_termos : "N");
    const [dadosParticipanteObrigatorio, alterarDadosParticipanteObrigatorio] = useState(clienteOriginal ? dados.dados_participante_obrigatorio : "N");
    const [cadastroParticipanteNome, alterarCadastroParticipanteNome] = useState(clienteOriginal ? dados.cadastro_participante_nome : "N");
    const [observacaoGrupo, alterarObservacaoGrupo] = useState(clienteOriginal ? dados.observacao_grupo : null);
    
    // formulário link
    const [seguroLinkXls, alterarSeguroLinkXls] = useState(clienteOriginal ? dados.seguro_link_xls : null);
    const [seguroLinkXlsCampos, alterarSeguroLinkXlsCampos] = useState(clienteOriginal ? dados.seguro_link_xls_campos : null);
    const [seguroAventuraTokenCheckin, alterarSeguroAventuraTokenCheckin] = useState(clienteOriginal ? dados.seguro_aventura_token_checkin : null);

    // monta link de propriedade
    const linkPropriedade = `${window.location.origin}/formularios/propostaSeguro/${seguroAventuraTokenCheckin}/propriedade`;    

    // função para controlar a copia do texto
    async function copiarParaTeclado(texto) {
        try {

            // copia para o teclado
            await navigator.clipboard.writeText(texto);

            // chama o toast para mostar a mensagem de sucesso
            toastCopiarTexto(
                "Copiado!", 
                "O texto selecionado foi copiado", 
                "success"
            );

        } catch (err) {

            // chama o toast dizendo o erro
            toastCopiarTexto(
                "Erro", 
                "Houve algum erro ao copiar o texto", 
                "danger"
            );

        }
    }

    // faz a requisição para o backend para gerar a imagem com qrcode do link do evento propriedade
    async function gerarImagemQrCodeEventoPropriedade() {

        // ativa o carregamento
        alterarCarregando(true);

        try {

            // faz a requisição
            const { data } = await axios.post(`/clientes/gerarQrcodeEventoPropriedade/${seguroAventuraTokenCheckin}`, null, {
                responseType: 'arraybuffer',
                headers: {
                    "Content-Type":	"image/png"
                }
            });

            // resgata imagem e cria um blob
            const blob = new Blob([data], { type: 'image/png' });

            // cria url a partir do blob
            const url = URL.createObjectURL(blob);

            // cria elemento <a>
            const a = document.createElement('a');
            a.href = url;

            // monta nome para o download
            a.download = `evento-propriedade-${dados.nome}.png`;

            // adiciona ao body
            document.body.appendChild(a);

            // realiza o clique
            a.click();

            // remove elemento e url
            a.remove();
            URL.revokeObjectURL(url);

        } catch(e) {
            console.log(e);

            // verifica se possui retorno de erro
            if(e.response && e.response.data) {

                // pega erros
                const erros = e.response.data;

                // resgata as chaves do objeto e percorre
                Object.keys(erros).forEach((erro) => {
                    toast(({ closeToast }) => <>
                        <div className="toast-header bg-danger text-white">
                            <strong className="mr-auto">Erro gerar imagem</strong>
                            <button
                                onClick={closeToast}
                                className="ml-2 mb-1 close btn-outline-light outline-0"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="toast-body bg-danger text-light">
                            {erros[erro]}
                        </div>
                    </>, { autoClose: 5000 })
                });
            }            
        } finally {
            // desativa o carregamento
            alterarCarregando(false);
        }

    }

    // consulta id do cliente
    async function consultarId() {

        // ativa o carregamento
        alterarCarregando(true);
        
        try {

            // faz a requisição
            const { data } = await axios.get(`/clientes/${idCliente}`);
            
            // altera estados com informações vindas do backend
            alterarIdClienteSeguradora(data.dados.id_cliente_seguradora);
            alterarCartaOferta(data.dados.carta_oferta);
            alterarNumeroApolice(data.dados.numero_apolice);
            alterarVigenciaApolice(data.dados.data_vigencia_apolice);
            alterarNumeroContrato(data.dados.numero_contrato);
            alterarNomeEvento(data.dados.seguro_evento_nome);
            alterarDescricaoEvento(data.dados.seguro_evento_descricao);
            alterarLocalEvento(data.dados.seguro_evento_local);
            alterarPlanoAdicionalDeslocamento(data.dados.plano_adicional_deslocamento);
            alterarIdPlano(data.dados.id_plano);
            alterarIdModeloEmailParticipante(data.dados.seguro_id_modelo_email_participante);
            alterarSeguroValorDiaria(data.dados.seguro_valor_diaria);
            alterarSeguroValorMorteAcidental(data.dados.seguro_valor_morte_acidental);
            alterarSeguroValorInvalidez(data.dados.seguro_valor_invalidez);
            alterarSeguroValorDmho(data.dados.seguro_valor_dmho);
            alterarSeguroHabilitarComprovanteParticipante(data.dados.seguro_habilitar_comprovante_participante);
            alterarSeguroHabilitarComprovanteParticipanteIndividual(data.dados.seguro_habilitar_comprovante_participante_individual);
            alterarSeguroEventoFinalizadoPermiteClienteNovo(data.dados.seguro_evento_finalizado_permite_cliente_novo);
            alterarBloquearEnvioEmailsSeguroAventura(data.dados.bloquear_envio_emails_seguro_aventura);
            alterarExibirTermos(data.dados.exibir_termos);
            alterarDadosParticipanteObrigatorio(data.dados.dados_participante_obrigatorio);
            alterarCadastroParticipanteNome(data.dados.cadastro_participante_nome);
            alterarSeguroLinkXls(data.dados.seguro_link_xls);
            alterarCamposJson(data.dados.seguro_link_xls_campos ? JSON.parse(data.dados.seguro_link_xls_campos) : camposJson);
            alterarSeguroAventuraTokenCheckin(data.dados.seguro_aventura_token_checkin);
            alterarDiariasCheckin(data.dados.diarias_evento_checkin ? JSON.parse(data.dados.diarias_evento_checkin) : []);
            
            // altera dados do contrato do cliente
            alterarDadosContratoAutentique(data.dadosContratoAutentique);

            // pega grupos do retorno
            alterarGruposCliente(data.grupos);

        } catch (e) {
            console.log(e);
        } finally {
            // desativa o carregamento
            alterarCarregando(false);
        }
    }

    // função para salvar cliente com seus dados do seguro aventura
    async function salvar() {

        // ativa o carregamento
        alterarCarregando(true);

        // monta dados para salvar
        const dadosSalvar = {
            ...dados,
            id: idCliente,
            id_plano: idPlano,
            id_cliente_seguradora: idClienteSeguradora,
            carta_oferta: cartaOferta,
            numero_apolice: numeroApolice,
            data_vigencia_apolice: vigenciaApolice,
            numero_contrato: numeroContrato,            
            seguro_evento_nome: nomeEvento,
            seguro_evento_descricao: descricaoEvento,
            seguro_evento_local: localEvento,
            plano_adicional_deslocamento: planoAdicionalDeslocamento,
            seguro_id_modelo_email_participante: idModeloEmailParticipante,
            seguro_valor_diaria: seguroValorDiaria,
            seguro_valor_morte_acidental: seguroValorMorteAcidental,
            seguro_valor_invalidez: seguroValorInvalidez,
            seguro_valor_dmho: seguroValorDmho,
            seguro_habilitar_comprovante_participante: seguroHabilitarComprovanteParticipante,
            seguro_habilitar_comprovante_participante_individual: seguroHabilitarComprovanteParticipanteIndividual,
            seguro_evento_finalizado_permite_cliente_novo: seguroEventoFinalizadoPermiteClienteNovo,
            bloquear_envio_emails_seguro_aventura: bloquearEnvioEmailsSeguroAventura,
            exibir_termos: exibirTermos,
            dados_participante_obrigatorio: dadosParticipanteObrigatorio,
            cadastro_participante_nome: cadastroParticipanteNome,
            seguro_link_xls: seguroLinkXls,
            seguro_aventura_token_checkin: seguroAventuraTokenCheckin,
            diarias_evento_checkin: JSON.stringify(diariasCheckin),
            seguro_link_xls_campos: JSON.stringify(camposJson),
            observacao_grupo: observacaoGrupo
        };

        // se for cliente cópia
        if(!clienteOriginal) {
            // adiciona copia aos parametros
            dadosSalvar['copia'] = "S";

            // adicioan id do cliente original aos parametros
            dadosSalvar['idClienteOriginal'] = dados.id;
        }

        try {

            // faz a requisição para salvar dados do cliente
            const { data } = await axios.post(`/clientes`, {
                modoUsuario,
                dados: dadosSalvar,
                grupos: gruposCliente,
                dadosUsuario
            });

            // se estiver cadastrando 
            if(!idCliente) {
                // remove carregamento
                alterarCarregando(false);

                // remove os ids nulos e adiciona novo id
                alterarIdsCliente(ids => {
                    const removeVazioArray = ids.filter(id => id !== null);
                    removeVazioArray.push(data.id);
                    return removeVazioArray;
                });
            } else {
                // consulta cliente
                consultarId();
            }

        } catch (e) {
            console.log(e);

            // remove carregamento
            alterarCarregando(false);

            // verifica se possui retorno de erro
            if (e.response && e.response.data) {

                // pega erros
                const erros = e.response.data;

                // resgata as chaves do objeto e percorre
                Object.keys(erros).forEach((erro) => {
                    toast(({ closeToast }) => <>
                        <div className="toast-header bg-danger text-white">
                            <strong className="mr-auto">Erro ao salvar o cliente</strong>
                            <button
                                onClick={closeToast}
                                className="ml-2 mb-1 close btn-outline-light outline-0"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="toast-body bg-danger text-light">
                            {erros[erro]}
                        </div>
                    </>, { autoClose: 5000 })
                });
            }

        }

    }    

    // monta token de diarias do cliente
    async function montaTokenDiariasCliente(numeroDiarias) {
        try {
            // caso não tiver valor, força o erro
            if(!numeroDiarias) throw new Error('Número de diárias é obrigatório');

            // gera o token para as diarias
            const tokens = await gerarTokenDiarias(idCliente, numeroDiarias);
            
            // faz a ordenação dos tokens e atualiza estado
            ordenaTokenCheckinCliente(tokens);
        } catch(e) {            
            toast(({ closeToast }) => <>
                <div className="toast-header bg-danger text-white">
                    <strong className="mr-auto">Erro ao gerar token</strong>
                    <button
                        onClick={closeToast}
                        className="ml-2 mb-1 close btn-outline-light outline-0"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="toast-body bg-danger text-light">
                    {e?.message ?? ''}
                </div>
            </>, { autoClose: 5000 })
        }
    }

    // decodifica array de objeto dos tokens e os ordena
    function ordenaTokenCheckinCliente(tokens) {
        // tranforma json em objeto
        let arrayDiariasCheckin = JSON.parse(tokens);

        // faz a ordenação
        arrayDiariasCheckin = arrayDiariasCheckin
            .sort((a, b) => {

                // resgata número de diárias
                const num1 = a.numeroDiarias;            
                const num2 = b.numeroDiarias;

                // faz as verificações e retorna true ou false para o sort
                if (num1 < num2) return -1;        
                if (num1 > num2) return 1;
    
                // mantem
                return 0;                    
            })
        ;

        // altera diaria checkin
        alterarDiariasCheckin(arrayDiariasCheckin);
    }
    
    // incluir nova observacao
    function incluirObservacao() {
        // monta nova observação
        const novaObservacao = {
            descricao: "",
            id: uniqid()
        };

        // cria nova observação do grupo
        const novaObservacaoGrupo = observacaoGrupo === null ? [novaObservacao] : observacaoGrupo.push(novaObservacao);

        // altera observação do grupo
        alterarObservacaoGrupo(novaObservacaoGrupo);
    }

    // faz a montagem de uma carta oferta
    function montaCartaOferta() {
        
        // resgata ano atual
        const anoAtual = moment(new Date()).format('Y');  

        // prepara cpf ou cnpj
        const cpfCnpj = (dados.cpf && dados.cpf.length === 11) ? dados.cpf : ((dados.cnpj && dados.cnpj.length === 14) ? dados.cnpj : '1234');

        // resgata as 6 primeiras letras
        const cpfCnpjFormatado = cpfCnpj.slice(0, 6);

        // prepara números aleatorios
        let numerosAleatorios = '';

        // percorre para gerar 4 numeros aleatorios
        for (let i = 0; i < 4; i++) {
            
            // concatena números aleatórios
            numerosAleatorios += Math.floor(Math.random() * 10);
            
        }            
        
        // monta carta oferta
        return anoAtual + cpfCnpjFormatado + numerosAleatorios;
    }

    // loga com a carta oferta do cliente
    function loginCliente() {

        // resgata servidor
        const { origin } = window.location
        
        // vai para a url designada para efetuar o login
        window.open(`${origin}/formularios/propostaSeguro?cartaOferta=${cartaOferta || ''}`, '_blank');        

    }
    
    useEffect(() => {                
        // somente consulta cliente se for diferente
        if(!clienteOriginal && idCliente) consultarId();

        // se é o cliente original e campos do link não estiver nulo
        if (clienteOriginal && seguroLinkXlsCampos !== null) {
            // faz alteração dos campos
            alterarCamposJson({ 
                ...camposJson, 
                ...JSON.parse(seguroLinkXlsCampos) 
            });
        }
    }, []);

    useEffect(() => {
        // atualiza grupos quando for cliente original
        if(clienteOriginal) alterarGruposCliente(grupos);
        
        // procura grupo seguro aventura no array de grupos do cliente original
        const grupoSeguroAventura = grupos.find(gp => gp.descricao === "Seguro Aventura");
        
        // se encontrou
        if(grupoSeguroAventura) {
            // procura se nos grupos do cliente atual há o grupo do seguro aventura
            const possuiGrupoSACliente = gruposCliente.some(gp => gp.descricao === "Seguro Aventura");
            
            // se ainda não há o grupo, insere
            if(!possuiGrupoSACliente) alterarGruposCliente([...gruposCliente, grupoSeguroAventura]);
        } else { // se não encontrou
            // remove o grupo seguro aventura 
            alterarGruposCliente(gruposCliente.filter(gc => gc.descricao !== "Seguro Aventura"));
        }
    }, [grupos]);
    
    useEffect(() => {        
        // se for nulo, altera para ser um array
        if(gruposCliente.length > 0 && observacaoGrupo === null) incluirObservacao();

        // se há seguro aventura propriedade selecionado
        alterarMostrarLinkCliente(gruposCliente.some(grupo => grupo.descricao === "Seguro Aventura Propriedade"));

        // se há seguro aventura selecionado
        alterarPossuiGrupoSeguroAventuraAtivo(gruposCliente.some(grupo => grupo.descricao === "Seguro Aventura Ativo"));

        // verifica se é para habilitar ou desabilitar esse campo
        const possuiGrupo = gruposCliente.find(grupo => grupo.id === configuracoes.habilitarCamposSeguroAventuraGrupo);

        // verifica se encontrou
        if(possuiGrupo !== habilitar) {
            alterarHabilitar(possuiGrupo);
        } else if(gruposCliente.length === 0) {
            alterarHabilitar(true);
        }
    }, [gruposCliente]);
    
    useEffect(() => {  
        // precisa estar no grupo seguro aventura
        // deve possuir cpf ou cnpj
        if(      
            possuiGrupoSeguroAventuraAtivo && 
            (
                dados.cpf.length === 11 || 
                dados.cnpj.length === 14
            ) && 
            (
                !cartaOferta ||
                cartaOferta.length === 0
            )
        ) {      

            // monta carta oferta
            const cartaOfertaFinal = montaCartaOferta();

            // se possui carta oferta
            if(
                cartaOfertaFinal && 
                cartaOfertaFinal.length > 4
            ) {

                // resgata a carta oferta
                const carta =  cartaOfertaFinal;

                // obtém o restante da carta oferta e inverte sua ordem
                const restoInvertido = carta.substring(4).split('').reverse().join('')
                    .replace(/[^a-zA-Z0-9]/g, '')
                    .replace('/', '')
                    .replace('-', '')
                ;
                
                // atualiza numero de apolice
                alterarNumeroApolice(restoInvertido);

            }

            alterarCartaOferta(cartaOfertaFinal);
        } 
    }, [possuiGrupoSeguroAventuraAtivo, dados.cpf, dados.cnpj]);

    // se informado link preenche
    useEffect(() => {
        // se possuir link xls, altera campos json
        if (seguroLinkXls !== null) alterarSeguroLinkXlsCampos(JSON.stringify(camposJson));
    }, [seguroLinkXls, camposJson]); 
    
    // se o valor for nulo, não renderiza ainda,
    if(
        configuracoes?.habilitarCamposSeguroAventuraGrupo === null ||
        !habilitar
    ) return <></>
    
    return (        
        <Card className={'border-0 shadow-sm mt-3 mb-4 relative'}>            
            <Row className='w-100'>
                <Col md='7' className='pr-0'>
                    <Card.Header className='border-0 pl-4' style={{ backgroundColor: '#fff' }}>
                        <Form.Group>
                            <div    
                                className={stylesCampos.containerLabelBotaoEvento}
                                style={{ justifyContent: 'flex-start' }}
                            >
                                <Form.Label
                                    className='font-weight-bold text-left fs-3'
                                    style={{
                                        fontSize: 24,
                                        marginLeft: -10
                                    }}
                                >
                                    {cartaOferta ? `Evento - ${cartaOferta ?? ''} ` : "Evento "}
                                </Form.Label>
                                {(cartaOferta && idCliente) && <button
                                    onClick={loginCliente}
                                    className={stylesCampos.botaoLinkEvento}
                                >
                                    <small>- Logar</small>
                                    <FontAwesomeIcon 
                                        className="icone" 
                                        icon={["fas", 'external-link-alt']} 
                                        size='sm'
                                    />
                                </button>}
                            </div>
                        </Form.Group>
                    </Card.Header>
                    <Card.Body className={stylesCampos[`corpoConteudo${!escondido ? 'Visivel' : 'Escondido'}`]}> 
                        <Form.Group>
                            <Form.Label>Seguradora</Form.Label>
                            <ComboCliente 
                                id={idClienteSeguradora}
                                alterou={novoId => alterarIdClienteSeguradora(novoId)}
                                filtrosExtras={{ grupos: [7] }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <div className={stylesCampos.containerLabelBotaoEvento}>
                                <Form.Label>
                                    Código Referência
                                </Form.Label>
                                {(cartaOferta && idCliente) && <button
                                    onClick={loginCliente}
                                    className={stylesCampos.botaoLinkEvento}
                                >
                                    <small>Logar</small>
                                </button>}
                            </div>
                            <Form.Control
                                value={cartaOferta || ''}
                                onChange={e => {
                                    // resgata a carta oferta
                                    const carta =  e.target.value;

                                    // se possui carta oferta
                                    if(
                                        e.target.value && 
                                        e.target.value.length > 4
                                    ) {                                    

                                        // obtém o restante da carta oferta e inverte sua ordem
                                        const restoInvertido = carta.substring(4).split('').reverse().join('')
                                            .replace(/[^a-zA-Z0-9]/g, '')
                                            .replace('/', '')
                                            .replace('-', '')
                                        ;
                                        
                                        // atualiza numero de apolice
                                        alterarNumeroApolice(restoInvertido);

                                    }

                                    // atualiza carta oferta
                                    alterarCartaOferta(carta);
                                }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <div className={stylesCampos.containerLabelBotaoEvento}>
                                <Form.Label>Nº. da Apólice</Form.Label>
                                <button
                                    onClick={downloadApolice}
                                    className={stylesCampos.botaoLinkEvento}
                                >
                                    {
                                        gerandoApolice ? 
                                            <FontAwesomeIcon 
                                                className="icone" 
                                                pulse 
                                                icon={["fas", 'spinner']} 
                                            /> : 
                                            <small>Emitir Apólice</small>
                                    }                            
                                </button>
                            </div>
                            <Form.Control
                                value={numeroApolice || ''}
                                onChange={e => alterarNumeroApolice(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Vigência da Apólice</Form.Label>
                            <InputData 
                                data={vigenciaApolice}
                                onChange={(data) => alterarVigenciaApolice(data)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <div className={stylesCampos.containerLabelBotaoEvento}>
                                <Form.Label>Nº. do Contrato</Form.Label>
                                {(idCliente && dadosContratoAutentique) ?
                                    <>
                                        <button
                                            onClick={() => emissaoContrato(idCliente)}
                                            className={stylesCampos.botaoLinkEvento}
                                        >
                                            {
                                                gerandoContrato ? 
                                                    <FontAwesomeIcon 
                                                        className="icone" 
                                                        pulse 
                                                        icon={["fas", 'spinner']} 
                                                    /> : 
                                                    <small>
                                                        {
                                                            dadosContratoAutentique.documento_assinado_cliente === "N" ? 
                                                                "Esperando assinatura do cliente" : 
                                                                "Gerar novamente"
                                                        }
                                                    </small>
                                            }                            
                                        </button>
                                        <button
                                            onClick={() => {
                                                // faz o download
                                                window.open(
                                                    dadosContratoAutentique.link_documento_autentique, 
                                                    '_blank'
                                                );
                                            }}
                                            className={stylesCampos.botaoLinkEvento}
                                        >
                                            <small>Baixar contrato</small>
                                        </button>    
                                    </> :
                                    <button
                                        onClick={async () => {
                                            await emissaoContrato(idCliente);
                                            consultarId();
                                        }}
                                        className='ml-2 text-decoration-none small btn btn-link d-flex align-items-start h-100 p-0 cursor-pointer mb-2'
                                    >
                                        {
                                            gerandoContrato ? 
                                                <FontAwesomeIcon 
                                                    className="icone" 
                                                    pulse 
                                                    icon={["fas", 'spinner']} 
                                                /> : 
                                                <small>Emitir Contrato</small>
                                        }                            
                                    </button>
                                }
                            </div>                    
                            <Form.Control
                                value={numeroContrato || ''}
                                onChange={e => alterarNumeroContrato(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Nome do evento</Form.Label>
                            <Form.Control
                                value={nomeEvento || ''}
                                onChange={e => alterarNomeEvento(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Descrição do evento</Form.Label>
                            <Form.Control
                                value={descricaoEvento || ''}
                                onChange={e => alterarDescricaoEvento(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Local do evento</Form.Label>
                            <Form.Control
                                value={localEvento || ''}
                                onChange={e => alterarLocalEvento(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check
                                inline
                                label="Adicional de Deslocamento"
                                type={'checkbox'}
                                checked={planoAdicionalDeslocamento === 'S'}
                                id={`checkbox-seguro-aventura-comprovante-participantes`}
                                onChange={(e) => {
                                    const checado = e.target.checked;
                                    alterarPlanoAdicionalDeslocamento(checado ? 'S' : 'N');

                                    // verifica se possui dados do plano do cliente
                                    const possuiDadosPlano = dadosPlano !== null;

                                    // se estiver checado
                                    if(checado) {
                                        // caso tiver um plano setado
                                        if(possuiDadosPlano) {
                                            // atualiza valor e modelo de email
                                            alterarSeguroValorDiaria(dadosPlano?.valor ? (parseFloat(dadosPlano.valor) + 0.29).toString() : dadosPlano?.valor);
                                            alterarIdModeloEmailParticipante(dadosPlano?.idModeloEmailDeslocamento);                            
                                        }              
                                        alterarSeguroValorDiaria((parseFloat(seguroValorDiaria) + 0.29).toString());
                                    } else {
                                        // caso tiver um plano setado
                                        if(possuiDadosPlano) {
                                            // atualiza valor e modelo de email
                                            alterarSeguroValorDiaria(dadosPlano?.valor);
                                            alterarIdModeloEmailParticipante(dadosPlano?.idModeloEmail);
                                        }  
                                        alterarSeguroValorDiaria((parseFloat(seguroValorDiaria) - 0.29).toString());
                                    }
                                }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Planos</Form.Label>
                            <ComboPlanos
                                id={idPlano}
                                alterou={dadosPlano => {
                                    
                                    // altera id do plano de acordo com dados
                                    alterarIdPlano(dadosPlano?.id ?? null);

                                    // verifica se o plano é personalizado
                                    const planoPersonalizado = dadosPlano && parseInt(dadosPlano.id) === 15;
                                    
                                    // se não for plano personalizado
                                    if(dadosPlano && !planoPersonalizado) {

                                        // atualiza valores
                                        alterarDadosPlano(dadosPlano);
                                        alterarSeguroValorMorteAcidental(dadosPlano?.valorMorteAcidental);
                                        alterarSeguroValorInvalidez(dadosPlano?.valorInvalidez);
                                        alterarSeguroValorDmho(dadosPlano?.valorDmho);
                                        alterarNumeroContrato(dadosPlano?.numeroContrato);
                                        alterarSeguroValorDiaria((planoAdicionalDeslocamento === 'S' && dadosPlano?.valor) ? (parseFloat(dadosPlano.valor) + 0.29).toString() : dadosPlano?.valor);
                                        alterarIdModeloEmailParticipante(planoAdicionalDeslocamento === 'S' ? dadosPlano?.idModeloEmailDeslocamento : dadosPlano?.idModeloEmail);                            
                                    } else {
                                        alterarDadosPlano(null);

                                        // remove deslocamento se for personalizado
                                        alterarPlanoAdicionalDeslocamento("N");
                                    }
                                }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Modelo de email para participante </Form.Label>
                            {/* seguro_id_modelo_email_participante */}
                            <ComboModeloEmail
                                id={idModeloEmailParticipante}
                                tipo={3}
                                alterou={idNovo => alterarIdModeloEmailParticipante(idNovo)}
                                desabilitado={idPlano && parseInt(idPlano) !== 15}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Valor</Form.Label>
                            <InputValor
                                valor={seguroValorDiaria || '0.0'}
                                onChange={valorNovo => alterarSeguroValorDiaria(valorNovo)}
                                disabled={idPlano && parseInt(idPlano) !== 15} // somente desabilita se o plano não for o personalizado
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Valor morte acidental</Form.Label>
                            <InputValor
                                valor={seguroValorMorteAcidental || '0.0'}
                                onChange={valorNovo => alterarSeguroValorMorteAcidental(valorNovo)}
                                disabled={idPlano && parseInt(idPlano) !== 15} // somente desabilita se o plano não for o personalizado
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Valor invalidez</Form.Label>
                            <InputValor
                                valor={seguroValorInvalidez || '0.0'}
                                onChange={valorNovo => alterarSeguroValorInvalidez(valorNovo)}
                                disabled={idPlano && parseInt(idPlano) !== 15} // somente desabilita se o plano não for o personalizado
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Valor DMHO {/* despesas médico-hospitalares odontológicas */}</Form.Label>
                            <InputValor
                                valor={seguroValorDmho || '0.0'}
                                onChange={valorNovo => alterarSeguroValorDmho(valorNovo)}
                                disabled={idPlano && parseInt(idPlano) !== 15} // somente desabilita se o plano não for o personalizado
                            />
                        </Form.Group>
                        <Form.Group className='mt-4'>
                            <Form.Check
                                inline
                                label="Enviar comprovante para os participantes?"
                                type={'checkbox'}
                                checked={seguroHabilitarComprovanteParticipante === 'S'}
                                id={`checkbox-seguro-aventura-comprovante-participantes`}
                                onChange={(e) => {
                                    alterarSeguroHabilitarComprovanteParticipante(e.target.checked ? 'S' : 'N');
                                }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check
                                inline
                                label="Enviar comprovante individual para o participante?"
                                type={'checkbox'}
                                checked={seguroHabilitarComprovanteParticipanteIndividual === 'S'}
                                id={`checkbox-seguro-aventura-comprovante-participante`}
                                onChange={(e) => {
                                    alterarSeguroHabilitarComprovanteParticipanteIndividual(e.target.checked ? 'S' : 'N');
                                }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check
                                inline
                                label="Permitir cadastrar cliente após evento finalizado?"
                                type={'checkbox'}
                                checked={seguroEventoFinalizadoPermiteClienteNovo === 'S'}
                                id={`checkbox-seguro-aventura-permitir-cadastrar-evento-apos-finalizado`}
                                onChange={(e) => alterarSeguroEventoFinalizadoPermiteClienteNovo(e.target.checked ? 'S' : 'N')}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check
                                inline
                                label="Não enviar e-mails dos eventos?"
                                type={'checkbox'}
                                checked={bloquearEnvioEmailsSeguroAventura === "S"}
                                id={`checkbox-bloquear-envio-emails-seguro-aventura`}
                                onChange={(e) => alterarBloquearEnvioEmailsSeguroAventura(e.target.checked ? 'S' : 'N')}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check
                                inline
                                label="Incluir Termo de Responsabilidade?"
                                type={'checkbox'}
                                checked={exibirTermos === 'S'}
                                id={`checkbox-exibir-termos`}
                                onChange={(e) => alterarExibirTermos(e.target.checked ? 'S' : 'N')}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check
                                inline
                                label="Dados dos participantes Obrigatório"
                                type={'checkbox'}
                                checked={dadosParticipanteObrigatorio === 'S'}
                                id={`checkbox-dados-participante-obrigatorio`}
                                onChange={(e) => {
                                    alterarDadosParticipanteObrigatorio(e.target.checked ? 'S' : 'N');
                                    alterarCadastroParticipanteNome((cadastroParticipanteNome === "S" && dadosParticipanteObrigatorio === 'N') ? "N" : cadastroParticipanteNome);
                                }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check
                                inline
                                label="Permitir Cadastrar participante somente com o Nome"
                                type={'checkbox'}
                                checked={cadastroParticipanteNome === 'S'}
                                id={`checkbox-dados-participante-obrigatorio`}
                                onChange={(e) => {              
                                    alterarCadastroParticipanteNome(e.target.checked ? 'S' : 'N');          
                                    alterarDadosParticipanteObrigatorio((dadosParticipanteObrigatorio === "S" && cadastroParticipanteNome === 'N') ? "N" : dadosParticipanteObrigatorio);
                                }}
                            />
                        </Form.Group>
                        {(exibirTermos === 'S') && <Form.Group
                            className='d-flex direction-row align-items-center justify-content-start'
                        >
                            <div 
                                className={['d-flex overflow-hidden align-items-center justify-content-start p-2', styles.containerArquivo].join(' ')}                                                
                            >                                            
                                <FontAwesomeIcon 
                                    style={{ color: 'red' }} 
                                    className="icone" 
                                    icon={["fas", "file-pdf"]} 
                                    size={"1x"}
                                />
                                <Form.Label 
                                    className='ml-2 mb-0 text-truncate'                                            
                                >
                                    Termo de responsabilidade
                                </Form.Label>
                            </div>   
                            <div>
                                <BotaoTabela 
                                    carregando={subindoTermoResponsabilidade}
                                    onClick={() => {
                                        if(arquivoRef && arquivoRef.current) arquivoRef.current.click();
                                    }}
                                    icone={["fas", "upload"]}
                                    tamanhoIcone={'sm'}
                                    color={'#000'}
                                    classe={styles.botaoArquivo}
                                    estiloBotao={{
                                        height: 40,
                                        border: '1px solid #284787',
                                        padding: '0.5rem 10px'
                                    }}
                                >                                            
                                    Fazer o upload do Termo de Responsabilidade
                                </BotaoTabela>
                                <Form.File 
                                    className='d-none' 
                                    ref={arquivoRef} 
                                    accept="application/pdf"
                                    onChange={realizarUploadTermo}
                                />                                                                                        
                            </div>
                            <BotaoTabela 
                                carregando={baixandoTermoResponsabilidade}
                                onClick={realizarDownloadTermo}
                                tamanhoIcone={'sm'}
                                color={'#000'}
                                icone={["fas", "download"]}
                                classe={styles.botaoArquivo}
                                estiloBotao={{
                                    height: 40,
                                    border: '1px solid #284787',
                                    padding: '0.5rem 10px',
                                    borderLeftWidth: 0,
                                    borderTopRightRadius: 5,
                                    borderBottomRightRadius: 5
                                }}
                            >
                                Fazer o download do Termo de Responsabilidade
                            </BotaoTabela>
                        </Form.Group>}                        
                    </Card.Body>
                </Col>
                <Col md='5' className='pl-0'>
                    <Card.Header className='border-0 pl-4 pr-0' style={{ backgroundColor: '#fff', height: 86 }}>
                        <Form.Group className='d-flex align-items-center justify-content-end'>                            
                            <FontAwesomeIcon 
                                className={[stylesCampos.iconeMaximizarMinimizar].join(' ')}
                                icon={['fas', !escondido ? 'chevron-up' : 'chevron-down']}
                                onClick={() => alterarEscondido(!escondido)}
                                fontSize={24}
                            />               
                            {/* no momento não irá poder remover cliente copiado */}
                            {(!clienteOriginal && idCliente === null) && <BotaoTabela 
                                onClick={() => {
                                    // cliente original não pode ser removido
                                    if(clienteOriginal) return;

                                    // remove do estado a partir do indice
                                    alterarIdsCliente(prevIds => prevIds.filter((_, index) => index !== indice));
                                }}
                                classe={[stylesCampos.botaoExcluirEvento, 'btn btn-padrao position-absolute rounded-circle'].join(' ')}
                                icone={["fas", "trash"]}
                            >
                                Excluir
                            </BotaoTabela>}
                        </Form.Group>
                    </Card.Header>
                    <Card.Body className={stylesCampos[`corpoConteudo${!escondido ? 'Visivel' : 'Escondido'}`]}> 
                        {!clienteOriginal && <Form.Group className={stylesCampos.containerComboGrupos}>
                            <ComboGrupos
                                grupos={gruposCliente}
                                onChange={(arrayGrupos) => {

                                    // percorre grupos e verifica se o grupo ativo já está inserido no array
                                    const possuiGrupoAtivo = gruposCliente.some(grupo => grupo.descricao === "Seguro Aventura Ativo");

                                    // percorre combo grupos e verifica se o grupo ativo foi selecionado
                                    const foiIncluidoGrupoAtivo = arrayGrupos.some(ag => ag.descricao === "Seguro Aventura Ativo");

                                    // se não estava no array mas foi incluido
                                    if(!possuiGrupoAtivo && foiIncluidoGrupoAtivo) {
                                        // caso grupo ativo for incluido, ativa o envio do comprovante individual para os participantes
                                        alterarSeguroHabilitarComprovanteParticipanteIndividual('S');
                                    }

                                    // atualiza grupos
                                    alterarGruposCliente(arrayGrupos);
                                }}
                                podeRemoverGrupoSeguroAventura={clienteOriginal}
                            />
                        </Form.Group>}
                        <Form.Group>
                            <Form.Label>Link XLS</Form.Label>
                            <Form.Control
                                value={seguroLinkXls || ""}
                                onChange={e => {
                                    // verifica se deixou o campo vazio
                                    const valorVazio = e.target.value === ""

                                    // verifica e altera o estado
                                    alterarSeguroLinkXls(valorVazio ? null : e.target.value);

                                    // se inseriu valor vazio
                                    if(valorVazio) {
                                        // zera campos
                                        alterarSeguroLinkXlsCampos(null);
                                        alterarCamposJson({
                                            linha: null,
                                            nome: "",
                                            cpf: "",
                                            email: "",
                                            dataNascimento: "",
                                            dataInicio: "",
                                            dataFinal: "",
                                            genero: "",
                                            telefone: ""
                                        });
                                    }
                                }}
                            />
                        </Form.Group>

                        {(seguroLinkXls !== null && seguroLinkXlsCampos !== null) &&
                            <>
                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label as={Col} lg={9}>Linha</Form.Label>
                                        <Col lg={3}>
                                            <Form.Control
                                                placeholder='2'
                                                value={camposJson.linha || ""}
                                                onChange={e => {
                                                    const linha = isNaN(parseInt(e.target.value)) ? null : parseInt(e.target.value);
                                                    alterarCamposJson({
                                                        ...camposJson,
                                                        linha
                                                    });
                                                }}
                                                size={'sm'}
                                            />
                                        </Col>
                                    </Form.Row>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label as={Col} lg={9}>Nome</Form.Label>
                                        <Col lg={3}>
                                            <Form.Control
                                                placeholder='ABC'
                                                value={camposJson.nome}
                                                onChange={e => {
                                                    alterarCamposJson({
                                                        ...camposJson,
                                                        nome: e.target.value
                                                    });
                                                }}
                                                size={'sm'}
                                            />
                                        </Col>
                                    </Form.Row>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label as={Col} lg={9}>Cpf/Cnpj</Form.Label>
                                        <Col lg={3}>
                                            <Form.Control
                                                placeholder='ABC'
                                                value={camposJson.cpf}
                                                onChange={e => {
                                                    alterarCamposJson({
                                                        ...camposJson,
                                                        cpf: e.target.value
                                                    });
                                                }}
                                                size={'sm'}
                                            />
                                        </Col>
                                    </Form.Row>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label as={Col} lg={9}>Email</Form.Label>
                                        <Col lg={3}>
                                            <Form.Control
                                                placeholder='ABC'
                                                value={camposJson.email}
                                                onChange={e => {
                                                    alterarCamposJson({
                                                        ...camposJson,
                                                        email: e.target.value
                                                    });
                                                }}
                                                size={'sm'}
                                            />
                                        </Col>
                                    </Form.Row>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label as={Col} lg={9}>Data Nascimento</Form.Label>
                                        <Col lg={3}>
                                            <Form.Control
                                                placeholder='ABC'
                                                value={camposJson.dataNascimento}
                                                onChange={e => {
                                                    alterarCamposJson({
                                                        ...camposJson,
                                                        dataNascimento: e.target.value
                                                    });
                                                }}
                                                size={'sm'}
                                            />
                                        </Col>
                                    </Form.Row>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label as={Col} lg={9}>Data Inicio</Form.Label>
                                        <Col lg={3}>
                                            <Form.Control
                                                placeholder='ABC'
                                                value={camposJson.dataInicio}
                                                onChange={e => {
                                                    alterarCamposJson({
                                                        ...camposJson,
                                                        dataInicio: e.target.value
                                                    });
                                                }}
                                                size={'sm'}
                                            />
                                        </Col>
                                    </Form.Row>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label as={Col} lg={9}>Data Final</Form.Label>
                                        <Col lg={3}>
                                            <Form.Control
                                                placeholder='ABC'
                                                value={camposJson.dataFinal}
                                                onChange={e => {
                                                    alterarCamposJson({
                                                        ...camposJson,
                                                        dataFinal: e.target.value
                                                    });
                                                }}
                                                size={'sm'}
                                            />
                                        </Col>
                                    </Form.Row>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label as={Col} lg={9}>Genero</Form.Label>
                                        <Col lg={3}>
                                            <Form.Control
                                                placeholder='ABC'
                                                value={camposJson.genero}
                                                onChange={e => {
                                                    alterarCamposJson({
                                                        ...camposJson,
                                                        genero: e.target.value
                                                    });
                                                }}
                                                size={'sm'}
                                            />
                                        </Col>
                                    </Form.Row>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label as={Col} lg={9}>Telefone</Form.Label>
                                        <Col lg={3}>
                                            <Form.Control
                                                placeholder='ABC'
                                                value={camposJson.telefone}
                                                onChange={e => {
                                                    alterarCamposJson({
                                                        ...camposJson,
                                                        telefone: e.target.value
                                                    });
                                                }}
                                                size={'sm'}
                                            />
                                        </Col>
                                    </Form.Row>
                                </Form.Group>
                            </>
                        }

                        {/* verifica e mostra link propriedade */}
                        {(mostrarLinkCliente && seguroAventuraTokenCheckin !== null) && <>                            
                            <Form.Group>
                                <Form.Label>Link do Cliente Propriedade</Form.Label>
                                <Form.Row className='ml-0 mr-0 d-flex'>
                                    <Col lg={9} className='p-0 d-flex'>
                                        <Form.Control
                                            value={linkPropriedade}
                                            disabled
                                            ref={refLinkPropriedade}
                                        />
                                    </Col>
                                    <Col lg={3} className='d-inline-flex align-items-center justify-content-end pl-0 pr-0'>
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={<Tooltip>Copiar link</Tooltip>}
                                        >
                                            <Button
                                                variant='padrao'
                                                className='mr-3'
                                                onClick={() => copiarParaTeclado(refLinkPropriedade.current.value)}
                                            >
                                                <FontAwesomeIcon icon={["fas", 'copy']} />
                                            </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={<Tooltip>Gerar QrCode</Tooltip>}
                                        >
                                            <Button
                                                variant='padrao'
                                                onClick={gerarImagemQrCodeEventoPropriedade}
                                            >
                                                <FontAwesomeIcon icon={["fas", 'qrcode']} />
                                            </Button>
                                        </OverlayTrigger>
                                    </Col>
                                </Form.Row>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Token do Cliente Propriedade</Form.Label>
                                <Form.Control
                                    value={seguroAventuraTokenCheckin ?? ''}
                                    placeholder={'Token seguro aventura propriedade'}
                                    onChange={e => alterarSeguroAventuraTokenCheckin(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Link com diárias</Form.Label>
                                <Form.Row 
                                    className='ml-0 mr-0 justify-content-between d-flex'
                                >
                                    <Col lg={10} className='p-0 d-flex'>
                                        <Form.Control
                                            value={numeroDiariasInput ?? ''}                                
                                            placeholder={'Número de diárias'}
                                            type={'number'}
                                            onChange={(e) => alterarNumeroDiariasInput(e.target.value)}
                                        />                                
                                    </Col>
                                    <Col lg={2} className='d-inline-flex align-items-start justify-content-end pr-0 pb-1'>
                                        <Button
                                            variant='padrao'
                                            onClick={() => {
                                                alterarNumeroDiariasInput(null);                                                
                                                montaTokenDiariasCliente(parseInt(numeroDiariasInput));
                                            }}
                                            disabled={carregamentoToken}
                                        >
                                            {carregamentoToken ?
                                                <FontAwesomeIcon 
                                                    className="icone" 
                                                    pulse 
                                                    icon={["fas", 'spinner']} 
                                                /> :
                                                <FontAwesomeIcon 
                                                    icon={["fas", 'plus']} 
                                                />
                                            }                                    
                                        </Button>
                                    </Col>
                                </Form.Row>
                            </Form.Group>
                            {diariasCheckin && diariasCheckin.length > 0 && diariasCheckin.map((diariaCheckin, index) => {
                                // monta link de propriedade com diarias
                                const linkPropriedadeDiarias = linkPropriedade + `/diarias/${diariaCheckin.numeroDiariasToken}`;

                                return (
                                    <Form.Group key={index}>
                                        <Form.Label>
                                            Número de diárias: {diariaCheckin.numeroDiarias}
                                        </Form.Label>
                                        <Form.Row 
                                            className='ml-0 mr-0 justify-content-between d-flex'
                                        >
                                            <Col lg={10} className='p-0 d-flex'>
                                                <Form.Control
                                                    value={linkPropriedadeDiarias}                                
                                                    disabled                                    
                                                />                                
                                            </Col>
                                            <Col lg={2} className='d-inline-flex align-items-start justify-content-end pr-0 pb-1'>
                                                <Button
                                                    variant='padrao'
                                                    onClick={() => copiarParaTeclado(linkPropriedadeDiarias)}
                                                >
                                                    <FontAwesomeIcon icon={["fas", 'copy']} />
                                                </Button>
                                            </Col>
                                        </Form.Row>
                                    </Form.Group>
                                )
                            })}                        
                        </>}
                    </Card.Body>
                </Col>
            </Row>
            {!escondido && (
                <Row className='w-100'>
                    <Form.Group className='d-flex justify-content-end my-4 w-100'>
                        <Button 
                            variant="success" 
                            onClick={salvar}
                            size={'lg'}
                        >
                            {idCliente ? "Salvar" : "Cadastrar"}
                        </Button>
                    </Form.Group>
                </Row>
            )}
            {carregando && 
                <Carregador className="rounded-bottom" />
            }
        </Card>
    )
}

export default memo(CamposSeguroAventura);